<div class="ticket-select-wrapper" [ngClass]="{'sector-select-collapsed': selectCollapsed || event.boEvent,
                                               'sector-select-wide': selectedSector && !selectedSector.hasSeats}">
  <ng-template #ticketSelectHeader let-mobile="mobile">
    <app-ticket-select-header [ngClass]="mobile ? 'mobile sticky-header' : 'desktop'"
                              [event]="event" [enabledSectorIds]="enabledSectorIds"
                              [(selectedView)]="selectedView" (sectorSelected)="handleSectorSelection($event)"
                              [showPromocode]="showPromocode" (promocodeChanged)="promocodeChanged()"></app-ticket-select-header>
  </ng-template>
  <ng-container *ngTemplateOutlet="ticketSelectHeader; context: {mobile: true}"></ng-container>
  <div class="flex flex-column" [ngClass]="{'mobile': selectCollapsed}">
    <ng-container *ngTemplateOutlet="ticketSelectHeader"></ng-container>
    <div *ngIf="hasVenueMap">
      <mat-slide-toggle class="mobile" [(ngModel)]="displayVenueMap" [ngModelOptions]="{standalone: true}">
        {{'general.api_venue_map_toggle' | translate}}
      </mat-slide-toggle>
    </div>
    <mat-card appearance="outlined" class="no-margin select-sector-card"
              [ngClass]="{'reduced-height': cartService.cart?.legacyPromocode, 'increased-height': !showPromocode, 'desktop': hasVenueMap && displayVenueMap}">
      <app-ticket-select-types *ngIf="event.boEvent" [event]="event"
                               (updateCart)="updateCartWithCaller()"
                               (openCustomerScreen)="openCustomerScreen()"></app-ticket-select-types>
      <app-ticket-select-sector *ngIf="!event.boEvent" [eventId]="event?.eventId"
                                [hasVenueMap]="hasVenueMap"
                                [selectedView]="selectedView"
                                [suggestEnabled]="suggestEnabled"
                                [enabledSectors]="getEnabledSectors"
                                [selectedSector]="selectedSector"
                                (backToSectorSelection)="backToSectorSelection()"
                                (selectSectorById)="selectSectorById($event)"
                                (hoverOnActiveSector)="hoverOnActiveSector($event)"
                                (updateSuggest)="tryToUpdateSuggest()"
                                (updateCart)="updateCartWithCaller()"
                                (loading)="$event ? startLoader() : stopLoader()"
                                [(selectedPriceClassIds)]="selectedPriceClassIds"
                                [(suggestedTickets)]="suggestedTickets"></app-ticket-select-sector>
    </mat-card>
    <ng-container *ngIf="utilService.isMobile && !event.boEvent" [ngTemplateOutlet]="venueTemplate" [ngTemplateOutletContext]="{mobile: true}"></ng-container>
  </div>
  <ng-container *ngIf="!event.boEvent" [ngTemplateOutlet]="venueTemplate"></ng-container>
</div>
<ng-template #venueTemplate let-mobile="mobile">
  <mat-card appearance="outlined" class="mobile no-margin" *ngIf="mobile && selectedSector" [ngStyle]="{display: displayVenueMap ? 'block' : 'none'}">
    <div class="flex flex-center">
      <button mat-button class="icon-button small" (click)="backToSectorSelection()" *ngIf="getEnabledSectors.length > 1">
        <mat-icon class="svg-icon" [svgIcon]="'arrow_left'"></mat-icon>
      </button>
      <div class="heading-5 no-margin">{{ selectedSector.name | translate }}</div>
    </div>
  </mat-card>
  <mat-card appearance="outlined" class="ticket-select-venue-wrapper no-margin" [ngClass]="mobile ? 'mobile' : 'desktop'"
            [ngStyle]="{display: (!mobile || displayVenueMap) ? 'block' : 'none'}">
    <ng-container *ngIf="getEnabledSectors?.length">
      <app-loader [loading]="isLoading" [overlay]="true"></app-loader>
      <app-venue-map [ngClass]="{'drag-disabled': disableCanvasDragging}"
                     [displayVenueMap]="displayVenueMap"
                     (venueMapExists)="hasVenueMap = $event"
                     [confId]="event.confId"
                     [sectionsMapType]="'vector'"
                     [sectionDetails]="selectedSector"
                     [currency]="authService.currencySymbol"
                     [sections]="eventSectors"
                     [enabledSections]="enabledSectorIds"
                     [selectedSection]="selectedSector"
                     [activeSection]="activeSectorId"
                     [selectedSeats]="selectedSeatIds"
                     [selectedSeatsAmount]="selectedSeatsAmount"
                     [deselectedSeats]="deselectedSeatIds"
                     [disableCanvasDragging]="disableCanvasDragging"
                     [clientName]="customerName"
                     [showMiniVenueMap]="updateMiniVenueMap"
                     [zoomLevel]="0"
                     [externalResize]="selectCollapsed"
                     [canRefund]="refundVisible"
                     [refundMode]="refundMode"
                     [windowMode]="routeService.isWindow"
                     [suggestEnabled]="suggestEnabled"
                     [mobileVenueMap]="mobile"
                     (sectionSelected)="selectSectorById($event)"
                     (sectionHover)="hoverOnActiveSector($event)"
                     (selected)="addSeatById($event)"
                     (deselected)="removeSeatById($event)"
                     (bookedSeatClicked)="openBooking($event)"
                     (bookedSeatHovered)="updateBookingClient($event)"
                     (refundSave)="refundModeSave()"
                     (refundClear)="refundModeClear()"
                     (openCustomerScreen)="openCustomerScreen()"
      ></app-venue-map>
      <div *ngIf="selectedSector && !selectedSector.hasSeats" class="venue-as-icon">
        <mat-icon class="svg-icon" [svgIcon]="'ticket'"></mat-icon>
        <div class="heading-5 text-grey medium">{{'general.api_venue_map_standing_places' | translate}}</div>
      </div>
      <div *ngIf="!selectedSector && !hasVenueMap" class="venue-as-icon">
        <mat-icon class="svg-icon" [svgIcon]="'location'"></mat-icon>
        <div class="heading-5 text-grey medium">{{ event.venueTitle }}</div>
      </div>
    </ng-container>
    <div class="collapse-button" *ngIf="!routeService.isWindow && !mobile">
      <button mat-button class="icon-button small" (click)="selectCollapsed = !selectCollapsed">
        <mat-icon class="svg-icon" [svgIcon]="selectCollapsed ? 'arrow_right' : 'arrow_left'"></mat-icon>
      </button>
    </div>
  </mat-card>
</ng-template>
